import React, { useEffect, useState, useRef } from 'react';
import './configuration-pdf-template.css';
import { Utility } from '../../../utility';

export const ConfigurationPdfTemplate = ({
  schematicOverview,
  schematicTopView,
  overview,
  tableData = [],
  $pdfLoadedCallback,
  translations,
  address,
  enquiryNumber,
  link,
}) => {
  const pdfRef = useRef(null);
  const [backgroundImage, setBackgroundImage] = useState('');
  const [imgLoadedCounter, setImgLoadedCounter] = useState(0);
  const [resizedSchematicOverview, setResizedSchematicOverview] = useState(null);
  const [resizedSchematicTopView, setResizedSchematicTopView] = useState(null);
  const { configUrl, configDisplayUrl, qrDisplayText, qrCode } = link;
  const imgLoaded = () => {
    setImgLoadedCounter((prev) => prev + 1);
  };

  useEffect(() => {
    Utility.resizeImageToAspectRatio(schematicOverview, 105 / 70).then((x) => {
      setResizedSchematicOverview(x);
    });
    Utility.resizeImageToAspectRatio(schematicTopView, 55 / 60).then((x) => {
      setResizedSchematicTopView(x);
    });

    Utility.loadPdfAsImage(
      window.location.origin.startsWith('http://localhost')
        ? 'http://localhost:5500/configuration-download-template.pdf'
        : 'https://strapiwmc4hstore.blob.core.windows.net/website-pdfs/configuration-download-template.pdf',
    )
      .then((x) => Utility.resizeImage(x, 210 * 5, 297 * 5))
      .then((x) => {
        setBackgroundImage(x);
      });
  }, []);

  useEffect(() => {
    if (imgLoadedCounter === [...pdfRef.current.querySelectorAll('.pdf-page img')].length) {
      const pages = pdfRef.current.querySelectorAll('.pdf-page');
      $pdfLoadedCallback(pages);
    }
  }, [imgLoadedCounter]);

  return (
    <div ref={pdfRef}>
      <div className="pdf-page">
        <img
          className="background"
          onLoad={imgLoaded}
          onError={imgLoaded}
          src={backgroundImage}
          alt="Q-railing PDF background"
        ></img>
        <div className="pdf-h1" style={{ marginBottom: '1cm' }}>
          {translations['thank-you']}
        </div>
        {enquiryNumber && (
          <div style={{ marginBottom: '0.5cm', marginLeft: '2px' }}>
            <span style={{ fontWeight: 'bold' }}>{translations['enquiry-number'] + ': '}</span>
            <span>{enquiryNumber}</span>
          </div>
        )}
        <div className="pdf-overview" style={{ marginBottom: '1.25cm' }}>
          <table>
            {overview.map((x, i) => (
              <tr key={'overview-' + i}>
                <td style={{ paddingRight: '8px', fontWeight: 'bold' }}>{x[0]}</td>
                <td>{x[1] && x[1] !== '' ? x[1] : '-'}</td>
              </tr>
            ))}
          </table>
          {address && (
            <>
              <div className="overview-divider"></div>
              <table>
                {address.map((x, i) => (
                  <tr className={'address-' + i}>
                    <td style={{ paddingRight: '8px', fontWeight: 'bold' }}>{x[0]}</td>
                    <td>{x[1] && x[1] !== '' ? x[1] : '-'}</td>
                  </tr>
                ))}
              </table>
            </>
          )}
        </div>
        <div className="pdf-h1">{translations['schematic-title']}</div>
        <div className="schematics">
          <img
            onLoad={imgLoaded}
            onError={imgLoaded}
            className="schematic-overview"
            src={resizedSchematicOverview}
            alt="schematic-overview"
          />
          <img
            onLoad={imgLoaded}
            onError={imgLoaded}
            className="schematic-top-view"
            src={resizedSchematicTopView}
            alt="schematic-top-view"
          />
        </div>
        <div className="qr-code-wrapper" style={{ marginTop: enquiryNumber ? '2cm' : '3cm' }}>
          <div className="qr-code">
            <div className="white">
              <img onLoad={imgLoaded} onError={imgLoaded} src={qrCode} alt="QR code" style={{ marginBottom: '-3px' }} />
            </div>
          </div>
          <div className="qr-text">
            <div style={{ flexGrow: 1 }}></div>
            <div className="pdf-h3">{qrDisplayText}</div>
            <a href={configUrl}>{configDisplayUrl}</a>
            <div style={{ flexGrow: 1 }}></div>
          </div>
        </div>
      </div>
      <div className="pdf-page">
        <img
          className="background"
          onLoad={imgLoaded}
          onError={imgLoaded}
          src={backgroundImage}
          alt="Q-railing PDF background"
        ></img>
        <div className="pdf-h1" style={{ marginBottom: '1cm', marginTop: '0.5cm' }}>
          {translations['table-title']}
        </div>
        <div className="table">
          {tableData[0].map((x, colIndex) => (
            <span key={colIndex} className={'head cell c' + colIndex}>
              {colIndex === 1 ? '' : x}
            </span>
          ))}
          {tableData
            .slice(1)
            .splice(0, 8)
            .map((row, rowIndex) =>
              row.map((x, colIndex) => (
                <span key={`${rowIndex}-${colIndex}`} className={'cell c' + colIndex}>
                  {colIndex === 3
                    ? x.split(' ').join('')
                    : colIndex === 1
                      ? x && <img alt="product-image" src={x} onLoad={imgLoaded} onError={imgLoaded} />
                      : x}
                </span>
              )),
            )}
        </div>
      </div>
      {[...new Array(Math.ceil((tableData.length - 9) / 9))].map((_, i) => (
        <div key={'tbl-' + i} className="pdf-page">
          <img
            className="background"
            onLoad={imgLoaded}
            onError={imgLoaded}
            src={backgroundImage}
            alt="Q-railing PDF background"
          ></img>
          <div className="table">
            {tableData[0].map((x, colIndex) => (
              <span key={colIndex} className={'head cell c' + colIndex}>
                {colIndex === 1 ? '' : x}
              </span>
            ))}
            {tableData
              .slice(9 + i * 9)
              .splice(0, 9)
              .map((row, rowIndex) =>
                row.map((x, colIndex) => (
                  <span key={`${rowIndex}-${colIndex}`} className={'cell c' + colIndex}>
                    {colIndex === 3
                      ? x.split(' ').join('')
                      : colIndex === 1
                        ? x && <img alt="product-image" src={x} onLoad={imgLoaded} onError={imgLoaded} />
                        : x}
                  </span>
                )),
              )}
          </div>
        </div>
      ))}
    </div>
  );
};
